const routes =
    [
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "/dyn/auth" */ '#/auth/login'),
        },
        {
            path: '/new-login',
            name: 'new-login',
            component: () => import(/* webpackChunkName: "/dyn/auth" */ '#/auth/login'),
        },

        {
            path: '/register',
            name: 'register',
            component: () => import(/* webpackChunkName: "/dyn/auth" */ '#/auth/register'),

        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: () => import(/* webpackChunkName: "/dyn/auth" */ '#/auth/forgot-password'),

        },

        {
            path: '/verify/:type/:target',
            name: 'verify',
            component: () => import(/* webpackChunkName: "/dyn/auth" */ '#/auth/verify-email-or-mobile'),

        }

    ]

export default routes
